import { render, staticRenderFns } from "./ReportScreen.vue?vue&type=template&id=46513c9c&scoped=true&"
import script from "./ReportScreen.vue?vue&type=script&lang=js&"
export * from "./ReportScreen.vue?vue&type=script&lang=js&"
import style0 from "./ReportScreen.vue?vue&type=style&index=0&id=46513c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46513c9c",
  null
  
)

export default component.exports